module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_05@2x-56bf84e596e160e4e81a65e50959e405.webp";